import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f35fe96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-box" }
const _hoisted_2 = {
  key: 0,
  class: "action-box"
}

import { isEmpty, isNull } from '~/util'
import { ClickOutside as vClickOutside } from 'element-plus'
import { inject, nextTick, ref } from 'vue'
import { EditorInstance } from '../editor'
import { CommentSubmitParam, InjectionCommentFun, InjectionEmojiApi } from '~/index'

export interface CommentBoxApi {
  focus(): void
}

interface Props {
  placeholder: string
  contentBtn: string
  parentId?: number
  replay?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'comment-box',
  props: {
    placeholder: null,
    contentBtn: null,
    parentId: null,
    replay: null
  },
  emits: ["hide", "close"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'hide', event: Event): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placeholder: string
  contentBtn: string
  parentId?: number
  replay?: string
}



const content = ref('')
const action = ref(false)
const disabled = ref(true)
const editorRef = ref<EditorInstance>()
const popperRef = ref()



const submit = inject(InjectionCommentFun) as (obj: CommentSubmitParam) => void
const emoji = inject(InjectionEmojiApi)

// 提交评论的数据
const onSubmit = () => {
  submit({
    content: props.replay ? `回复 <span style='color: blue;'>@${props.replay}:</span> ${content.value}` : content.value,
    parentId: isNull(props.parentId, null),
    finish: () => {
      // 清空评论框内容
      (editorRef.value as any).clear()
      // 关闭评论框事件
      emit('close')
    }
  })
}

// 点击评论框外关闭操作栏和失去评论框焦点
function onClickOutside(event: Event) {
  // const child = event.target as HTMLElement
  // const target = document.querySelector(".el-popper")
  // if (!target?.contains(child) && isEmpty(content.value)) {
  //   action.value = false
  // }

  // 评论框有内容情况下不执行炒作
  if (isEmpty(content.value)) {
    action.value = false
    emit('hide', event)
  }
}

function onFocus() {
  // 显示操作栏
  action.value = true
  nextTick(() => {
    // 所有以'el-popper-container'开头的id且被选中的元素
    popperRef.value = document.querySelector("div[id^='el-popper-container']")
  })
}

expose({
  focus: () => (editorRef as any).value?.focus()
})

return (_ctx: any,_cache: any) => {
  const _component_u_editor = _resolveComponent("u-editor")!
  const _component_u_emoji = _resolveComponent("u-emoji")!
  const _component_el_button = _resolveComponent("el-button")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_u_editor, {
      ref_key: "editorRef",
      ref: editorRef,
      modelValue: content.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
      class: _normalizeClass({ 'input-active': action.value }),
      placeholder: props.placeholder,
      "min-height": 64,
      onFocus: onFocus,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(isEmpty)(content.value.replace(/  |<br>/g, '')) ? (disabled.value = true) : (disabled.value = false))),
      onSubmit: onSubmit
    }, null, 8, ["modelValue", "class", "placeholder"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (action.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_u_emoji, {
                emoji: _unref(emoji),
                onAddEmoji: _cache[2] || (_cache[2] = (val) => editorRef.value?.addText(val))
              }, null, 8, ["emoji"]),
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: disabled.value,
                onClick: onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.contentBtn), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_unref(vClickOutside), onClickOutside, popperRef.value]
  ])
}
}

})